import {jQuery as $, lodash as _} from 'lib/shim';



class ContextSingleton {

	constructor(){
		this._context = window.CONTEXT;
		if( !$.isSet(this._context) || !$.isPlainObject(this._context) ){
			this._context = {};
		}

		this._context = $.extend({
			debug : false,
			staticBase : '/',
			runningInPatternLab : false,
			runningInIframe : parent !== window,
			isTouchDevice : $.contextIsTouchDevice(false),
			cookieProConsentLevelForTracking : 2,
			currentCookieProConsentLevel : 1,
			googleTagManagerId : null,
		}, this._context);
	}



	//###( ACCESS )###

	set(key, value, force=false){
		if( this.has(key) && !force ){
			$.err('Context | cannot set key that already exits without force parameter');
		} else {
			this._context[key] = value;
		}
	}



	get(key, defaultVal){
		if( $.isSet(key) ){
			defaultVal = $.orDefault(defaultVal, null);

			return _.get(this._context, key, defaultVal);
		} else {
			return $.extend({}, this._context);
		}
	}



	has(key){
		return _.has(this._context, key);
	}



	remove(key){
		if( this.has(key) ){
			_.unset(this._context, key);
		}
	}



	//###( FUNCTIONALITY )###

	detectPatternlab(){
		this.set(
			'runningInPatternLab',
			this._context.runningInPatternLab || ($('html#patternlab-html').length > 0) || _.startsWith(window.name, 'sg-viewport'),
			true
		);

		this.set(
			'runningInPatternLabList',
			this.get('runningInPatternLab') && $.exists($('#sg-patterns'))
		);

		this.set(
			'runningInPatternLabTemplateOrPage',
			this.get('runningInPatternLab') && $.exists($('body > main'))
		);

		this.set(
			'runningInPatternLabDetails',
			this.get('runningInPatternLab') && !this.get('runningInPatternLabList') && !this.get('runningInPatternLabTemplateOrPage')
		);
	}

}



export let Context = new ContextSingleton();
